import {
    Avatar,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";

import uploadImage from "../../../../Assets/images/uploadImage.png";
import { Add, CloudUpload, Delete, Download } from "@mui/icons-material";
import LoadingAnimation from "../../../../Components/LottieAnimation/LoadingAnimation";
import GoogleMaps from "../../../../Layouts/GoogleMaps/GoogleMaps";
import {
    getAllState,
    resetState,
} from "../../../../Redux/StateSlice/stateSlice";
import { FormHeading } from "../../../../Layouts/Heading";
import { PrimaryButton } from "../../../../Layouts/ButtonsControlled";

import {
    BussinessLicenceInstaller,
    BussinessLicenceInstallerUpdate,
    getAllInstaller,
    GetSingleInstallerLicense,
    reset,
} from "../../../../Redux/InstallerSlice/InstallerSlice";
import { useParams } from "react-router-dom";

const EditInstallerLicense = () => {
    const { installer_id, license_id } = useParams();
    const { single_license, isLodaing, isSuccess, isError, errors } =
        useSelector((state) => state.installer);

    const dispatch = useDispatch();

    // Get All States
    const { states } = useSelector((state) => state.AllStates);
    const AllStates = states?.data?.states;
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, [dispatch]);

    const SingleLicense = single_license?.data || [];

    useEffect(() => {
        const CallLicenseMethod = async () => {
            await dispatch(GetSingleInstallerLicense(license_id));
            await dispatch(reset());
        };
        CallLicenseMethod();
    }, [license_id]);

    // ======================================================================
    // Start Handel All Of Method To Add && Delete && Edit Bussiness License
    // ======================================================================

    const handleLicenseImage = (e) => {
        formik.values.license_img = e.currentTarget.files[0];
    };
    const handleDriversLicense = (e) => {
        formik.values.drivers_license = e.currentTarget.files[0];
    };
    const handleWorkersCompInsurance = (e) => {
        formik.values.workers_comp_insurance = e.currentTarget.files[0];
    };
    const handleLiabilityInsurance = (e) => {
        formik.values.liability_insurance = e.currentTarget.files[0];
    };

    // ======================================================================
    // End Handel All Of Method To Add && Delete && Edit Bussiness License
    // ======================================================================

    // Handle Fetch Data From Google Maps

    const handleSomeValues = (index, full_address, lat, lng) => {
        // alert(full_address)
        formik.values.full_address = full_address;
        formik.values.lat = lat;
        formik.values.lng = lng;
    };

    const handleSetValues = (
        index,
        singleAdress,
        full_address,
        zip_code,
        street,
        country,
        state,
        route,
        city,
        coordinates
    ) => {
        // formik.values.full_address = full_address;
        console.log(state)
        formik.values.lat = coordinates.lat;
        formik.values.lng = coordinates.lng;
        formik.values.state_abbr = state;
        formik.values.state = city;
    };

    const [submitForm, setSubmitForm] = useState(false);

    const formik = useFormik({
        initialValues: {
            user_id: "",
            license_number: "",
            license_type: "",
            state_id: "",
            phone: "",
            license_expiration_date: "",
            license_img: null,
            drivers_license: null,
            workers_comp_insurance: null,
            liability_insurance: null,
            full_address: "",
            lat: "",
            lng: "",
            state_abbr: "",
            dstOffset: "",
            rawOffset: "",
            timeZoneId: "",
            timeZoneName: "",
            license_holder: "",
        },

        onSubmit: async (values) => {
            setSubmitForm(true);
            await dispatch(
                BussinessLicenceInstallerUpdate({
                    data: values,
                    license_id: license_id,
                })
            );
            await dispatch(reset());
        },
    });

    useEffect(() => {
        if (isSuccess && submitForm) {
            toast.success("The Licenses has been added successfully");
        }
    }, [isSuccess]);

    useEffect(() => {
        if (SingleLicense) {
            formik.values.user_id = installer_id;
            formik.values.license_number = SingleLicense?.license_number || "";
            formik.values.license_type =
                parseInt(SingleLicense?.license_type) || "";
            formik.values.state_id = SingleLicense?.state_id || "";
            formik.values.phone = SingleLicense?.phone || "";
            formik.values.license_expiration_date =
                SingleLicense?.license_expiration_date || "";
            formik.values.dstOffset = SingleLicense?.dstOffset || "";
            formik.values.rawOffset = SingleLicense?.rawOffset || "";
            formik.values.full_address = SingleLicense?.full_address || "";
            formik.values.lat = SingleLicense?.lat || "";
            formik.values.lng = SingleLicense?.lng || "";
            formik.values.state_abbr = SingleLicense?.state_abbr || "";
            formik.values.timeZoneId = SingleLicense?.time_zone_id || "";
            formik.values.timeZoneName = SingleLicense?.time_zone_name || "";
            formik.values.license_holder = SingleLicense?.license_holder || "";
            formik.values.license_holder = SingleLicense?.license_holder || "";
            formik.values.license_holder = SingleLicense?.license_holder || "";
        }
    }, [SingleLicense]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                if (errors.length < 8) {
                    Object.keys(errors).forEach((key) => {
                        let error = errors[key][0];
                        toast.error(error);
                    });
                } else {
                    toast.error(errors);
                }
            }
            const resetMethod = async () => {
                await dispatch(reset());
            };
            resetMethod();
        }
    }, [isError]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <FormContainer>
                    <form onSubmit={formik.handleSubmit}>
                        <Card style={{ padding: "15px", clear: "both" }} mb={3}>
                            <FormHeading>Edit Business License</FormHeading>
                            <Grid container columns={12} spacing={3}>
                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="license_holder"
                                        name="license_holder"
                                        label="License Holder"
                                        value={formik.values.license_holder}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="license_number"
                                        name="license_number"
                                        label="Licence Number"
                                        value={formik.values.license_number}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <FormControl fullWidth required={true}>
                                        <InputLabel id="demo-simple-select-label">
                                            License Type
                                        </InputLabel>
                                        <Select
                                            id="license_type"
                                            name="license_type"
                                            label="License Type"
                                            required
                                            value={formik.values.license_type}
                                            onChange={formik.handleChange}
                                        >
                                            <MenuItem value={1}>
                                                Roofing
                                            </MenuItem>
                                            <MenuItem value={2}>HVAC</MenuItem>
                                            <MenuItem value={3}>
                                                Electrical
                                            </MenuItem>
                                            <MenuItem value={4}>Solar</MenuItem>
                                            <MenuItem value={5}>
                                                General
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <FormControl fullWidth required={true}>
                                        <InputLabel id="demo-simple-select-label">
                                            State
                                        </InputLabel>
                                        <Select
                                            id="state_id"
                                            name="state_id"
                                            label="State"
                                            required
                                            value={formik.values.state_id}
                                            onChange={formik.handleChange}
                                        >
                                            {AllStates?.map((key) => (
                                                <MenuItem
                                                    key={key.id}
                                                    value={key.id}
                                                >
                                                    {key.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="phone"
                                        name="phone"
                                        label="Phone"
                                        value={formik.values.phone}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        id="license_expiration_date"
                                        name="license_expiration_date"
                                        label="Licence Expiration date"
                                        type="date"
                                        value={
                                            formik.values
                                                .license_expiration_date
                                        }
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <GoogleMaps
                                        index={0}
                                        formik={formik}
                                        handleSetValues={handleSetValues}
                                        handleSomeValues={handleSomeValues}
                                    ></GoogleMaps>

                                    {/* <Typography
                                        variant="h6"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        Full Address :
                                        {formik.values.full_address}
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        State Abbr :{formik.values.state_abbr}
                                    </Typography> */}
                                </Grid>
                                <Grid item mb={1} xs={12} md={6}>
                                    <Typography
                                        variant="lable"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "700",
                                                color: "#888",
                                            }}
                                            variant="span"
                                            align="center"
                                        >
                                            License Image
                                            {SingleLicense?.file
                                                ?.license_img && (
                                                <DownloadHREF
                                                    href={
                                                        SingleLicense?.file
                                                            ?.license_img
                                                    }
                                                    download
                                                    target="_blank"
                                                >
                                                    <Download />
                                                </DownloadHREF>
                                            )}
                                        </Typography>
                                    </Typography>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        component="label"
                                    >
                                        <CloudUpload />
                                        <span mr={2} ml={2}>
                                            Upload
                                        </span>
                                        <input
                                            hidden
                                            type="file"
                                            name="license_img"
                                            id="license_img"
                                            onChange={(e) =>
                                                handleLicenseImage(e)
                                            }
                                        />
                                    </Button>
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <Typography
                                        variant="lable"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "700",
                                                color: "#888",
                                            }}
                                            variant="span"
                                            align="center"
                                        >
                                            Drivers License
                                            {SingleLicense?.file
                                                ?.drivers_license && (
                                                <DownloadHREF
                                                    href={
                                                        SingleLicense?.file
                                                            ?.drivers_license
                                                    }
                                                    download
                                                    target="_blank"
                                                >
                                                    <Download />
                                                </DownloadHREF>
                                            )}
                                        </Typography>
                                    </Typography>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        component="label"
                                    >
                                        <CloudUpload />
                                        <span mr={2} ml={2}>
                                            Upload
                                        </span>
                                        <input
                                            hidden
                                            type="file"
                                            name="drivers_license"
                                            id="drivers_license"
                                            onChange={(e) =>
                                                handleDriversLicense(e)
                                            }
                                        />
                                    </Button>
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <Typography
                                        variant="lable"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "700",
                                                color: "#888",
                                            }}
                                            variant="span"
                                            align="center"
                                        >
                                            Workers Comp Insurance
                                            {SingleLicense?.file
                                                ?.workers_comp_insurance && (
                                                <DownloadHREF
                                                    href={
                                                        SingleLicense?.file
                                                            ?.workers_comp_insurance
                                                    }
                                                    download
                                                    target="_blank"
                                                >
                                                    <Download />
                                                </DownloadHREF>
                                            )}
                                        </Typography>
                                    </Typography>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        component="label"
                                    >
                                        <CloudUpload />
                                        <span mr={2} ml={2}>
                                            Upload
                                        </span>
                                        <input
                                            hidden
                                            type="file"
                                            name="workers_comp_insurance"
                                            id="workers_comp_insurance"
                                            onChange={(e) =>
                                                handleWorkersCompInsurance(e)
                                            }
                                        />
                                    </Button>
                                </Grid>

                                <Grid item mb={1} xs={12} md={6}>
                                    <Typography
                                        variant="lable"
                                        id="document"
                                        label="document"
                                        align="justify"
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: "700",
                                                color: "#888",
                                            }}
                                            variant="span"
                                            align="center"
                                        >
                                            Liability Insurance
                                            {SingleLicense?.file
                                                ?.liability_insurance && (
                                                <DownloadHREF
                                                    href={
                                                        SingleLicense?.file
                                                            ?.liability_insurance
                                                    }
                                                    download
                                                    target="_blank"
                                                >
                                                    <Download />
                                                </DownloadHREF>
                                            )}
                                        </Typography>
                                    </Typography>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        component="label"
                                    >
                                        <CloudUpload />
                                        <span mr={2} ml={2}>
                                            Upload
                                        </span>
                                        <input
                                            hidden
                                            type="file"
                                            name="liability_insurance"
                                            id="liability_insurance"
                                            onChange={(e) =>
                                                handleLiabilityInsurance(e)
                                            }
                                        />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Save"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
const DownloadHREF = styled.a`
    color: green;
    margin: 10px;
`;
export default EditInstallerLicense;
